export class Link {
  public readonly url: string;
  public readonly title: string;

  public constructor(url: string, title: string) {
    this.url = url;
    this.title = title;
  }

}
